// https://muffinman.io/react-router-subfolder-on-server/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import StoreProvider from "./Store/Provider";
import {RoutesPrivate} from "./Components/Constants/Routes/Private";
import Login from "./Components/Login/Index";

import Announcement from "./Components/Admin/Announcement/Index";
import Layout from "./Components/Student/Layout/Index";
import LayoutContabilidad from "./Components/Student/Layout/LayoutContabilidad";
import LayoutAdmin from "./Components/Student/Layout/Admin";
import LayoutDireccion from "./Components/Student/Layout/LayoutDireccion";
import LayoutParents from "./Components/Student/Layout/Parents";
import LayoutTeacher from "./Components/Student/Layout/Teachers"
import Person from "./Components/Admin/Person/Index";
import Password from "./Components/Admin/Password/Index";
import Grades from "./Components/Admin/Grades/Index";
import Registration from "./Components/Admin/Registration/Index";
import Boletines from "./Components/Admin/Boletines/Index";
import Hour from "./Components/Admin/Hour/Index";
import Retired from "./Components/Admin/Retired/Index";
import Setup from "./Components/Admin/Setup/Index";
import ACycle from "./Components/Admin/ACycles/Index"
import Activation from "./Components/Admin/Activation/Index";
import Cycles from "./Components/Admin/Cycles/Index";
import Plans from "./Components/Admin/Plans/Index";
import Teachers from "./Components/Admin/Teachers/Index";
import Subjects from "./Components/Admin/Materias/Index";
import AConsejeria from "./Components/Admin/AConsejeria/Index";
import AMaterias from "./Components/Admin/AMaterias/Index";
import Cuentas from "./Components/Contabilidad/Cuentas/Index";
import Montos from "./Components/Contabilidad/Montos/Index";
import RPagos from "./Components/Contabilidad/RPagos/Index";
import Informes from "./Components/Contabilidad/Informes/Index";
import ECuentas from "./Components/Contabilidad/ECuentas/Index"
import SubjectByPlan from './Components/Admin/SubjectByPlan/Index';

import Schedule from "./Components/Student/Schedule/Index";
import Payments from "./Components/Student/Payments/Index";
import Home from "./Components/Student/Home/Index";
import Notes from "./Components/Student/Notes/Index";
import Messages from "./Components/Student/Messages/Index";
import Agenda from "./Components/Student/Agenda/Index";

import HomeTeacher from "./Components/Teachers/Home/Index";
import Consejeria from "./Components/Teachers/Consejeria/Index";
import HourTeacher from "./Components/Teachers/Hour/Index";
import MensajesTeacher from "./Components/Teachers/Message/Index";
import Notebook from './Components/Teachers/Libreta/Index';
import Lobby from './Components/Student/Lobby/Index';

import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import "./www/css/fonts.css";
import AgendaTeacher from "./Components/Teachers/Agenda/Index";
// import Correos from "./Components/Contabilidad/Correos/Index";

const App = () => {
  return <BrowserRouter basename="/scorecard">
    <StoreProvider>
      <Switch>
        {/* <Route   path={process.env.PUBLIC_URL + '/'} component={Login} /> */}
        <Route   path="/login" component={Login} />
        <Route   path="/lobby" component={Lobby} />
        
        <Route  path='/admin/:path?' exact >
        <LayoutAdmin>
          <RoutesPrivate exact path="/admin/home" component={Person}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/announcement" component={Announcement}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/password" component={Password}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/grades" component={Grades}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/registration" component={Registration}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/boletin" component={Boletines}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/hour" component={Hour}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/retired" component={Retired}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/setup" component={Setup}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/subjects" component={Subjects}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/activation" component={Activation}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/cycles" component={Cycles}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/plans" component={Plans}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/teachers" component={Teachers}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/a-consejeria" component={AConsejeria}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/a-subject" component={AMaterias}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/cuentas" component={Cuentas}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/area-by-cycle" component={ACycle}></RoutesPrivate>
          <RoutesPrivate exact path="/admin/subject-by-plan" component={SubjectByPlan}></RoutesPrivate>
        </LayoutAdmin>
        </Route>

        <Route  path='/student/:path?' exact>
        <Layout>
            <RoutesPrivate exact path="/student/home" component={Home}></RoutesPrivate>
            <RoutesPrivate exact path="/student/agenda" component={Agenda}></RoutesPrivate>
            <RoutesPrivate exact path="/student/notes" component={Notes}></RoutesPrivate>
            <RoutesPrivate exact path="/student/messages" component={Messages}></RoutesPrivate>
            <RoutesPrivate exact path="/student/schedule" component={Schedule}></RoutesPrivate>
            <RoutesPrivate exact path="/student/payment" component={Payments}></RoutesPrivate>         
        </Layout>
        </Route>

        <Route  path='/parents/:path?' exact>
        <LayoutParents>
            <RoutesPrivate exact path="/parents/home" component={Home}></RoutesPrivate>
            <RoutesPrivate exact path="/parents/agenda" component={Agenda}></RoutesPrivate>
            <RoutesPrivate exact path="/parents/notes" component={Notes}></RoutesPrivate>
            <RoutesPrivate exact path="/parents/schedule" component={Schedule}></RoutesPrivate>
            <RoutesPrivate exact path="/parents/payment" component={Payments}></RoutesPrivate>         
        </LayoutParents>
        </Route>

        <Route  path='/teachers/:path?' exact>
        <LayoutTeacher>
            <RoutesPrivate exact path="/teachers/home" component={HomeTeacher}></RoutesPrivate>
            <RoutesPrivate exact path="/teachers/consejeria" component={Consejeria}></RoutesPrivate>
            <RoutesPrivate exact path="/teachers/notebook" component={Notebook}></RoutesPrivate>
            <RoutesPrivate exact path="/teachers/messages" component={MensajesTeacher}></RoutesPrivate>
            <RoutesPrivate exact path="/teachers/agenda" component={AgendaTeacher}></RoutesPrivate>
            <RoutesPrivate exact path="/teachers/calendar" component={HourTeacher}></RoutesPrivate>         
        </LayoutTeacher>
        </Route>

        <Route  path='/direccion/:path?' exact>
        <LayoutDireccion>
            <RoutesPrivate exact path="/direccion/registration" component={Registration}></RoutesPrivate>
            <RoutesPrivate exact path="/direccion/boletin" component={Boletines}></RoutesPrivate>
            <RoutesPrivate exact path="/direccion/hour" component={Hour}></RoutesPrivate>
            <RoutesPrivate exact path="/direccion/retired" component={Retired}></RoutesPrivate>
            <RoutesPrivate exact path="/direccion/teachers" component={Teachers}></RoutesPrivate>
            <RoutesPrivate exact path="/direccion/activation" component={Activation}></RoutesPrivate>         
        </LayoutDireccion>
        </Route>

        <Route  path='/contabilidad/:path?' exact>
        <LayoutContabilidad>
            <RoutesPrivate exact path="/contabilidad/personas" component={Person}></RoutesPrivate>
            <RoutesPrivate exact path="/contabilidad/montos" component={Montos}></RoutesPrivate>
            <RoutesPrivate exact path="/contabilidad/r-pagos" component={RPagos}></RoutesPrivate>
            <RoutesPrivate exact path="/contabilidad/cuentas" component={Cuentas}></RoutesPrivate>
            <RoutesPrivate exact path="/contabilidad/estado-cuentas" component={ECuentas}></RoutesPrivate>
            <RoutesPrivate exact path="/contabilidad/informes" component={Informes}></RoutesPrivate>
            {/* <RoutesPrivate exact path="/contabilidad/email" component={Correos}></RoutesPrivate> */}
        </LayoutContabilidad>
        </Route>
      </Switch>
    </StoreProvider>
  </BrowserRouter>
};

ReactDOM.render(<App />, document.getElementById("root"));

serviceWorker.unregister();
